import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'src/shared/components/tooltip';
export function Stat({ icon, label = '', value }) {
    const id = useId();
    return (_jsx(Tooltip, { text: label, disabled: !label, children: _jsxs("div", { className: "flex items-center gap-1 text-extrasmall text-neutral-500", children: [_jsx("dt", { id: id, "aria-label": label, children: _jsx(FontAwesomeIcon, { icon: icon, "aria-label": label }) }), _jsx("dd", { "aria-labelledby": id, role: "definition", children: value })] }) }));
}
